// @flow
import * as desktopAppearance from './desktop'

export const Container = {
  height: '100%',
  display: 'flex',
  flexFlow: 'column nowrap',
}

export const Content = {
  padding: '0 10px',
  flexGrow: 1,
}

export const { ButtonContainer } = desktopAppearance
